export default __webpack_public_path__ + "static/media/icon_view.8489b799.svg";